export default {
    'AUTH.RESET_PASSWORD.TITLE': 'Réinitialiser mon mot de passe',

    'AUTH.RESET_PASSWORD.FORM.PASSWORD_NEW.LABEL': 'Confirmez votre nouveau mot de passe',

    'AUTH.RESET_PASSWORD.BUTTON': 'Confirmer',
};
